import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Dimmer } from "../spinner";
import { Mensaje } from "../mensajes";
import { ModalActualizarDeudaMina } from "./modalActualizarDeudaMina";
import TablaHistoricoMinas from "./historicoDeudaMinas";
import useTableChecked from "../useTableChecked";
import { Checkbox, TableBody, TableCell, TableRow } from "@material-ui/core";
import { formatMoneda, TIPODEUDA } from "../../util/varios";

export const ModalGestionDeudaMina = (props) => {
  const op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const accdeudamina = JSON.parse(localStorage.getItem("accdeudamina"));

  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [show, setShow] = useState(false);
  const [deuda, setDeuda] = useState([]);
  const [historico, setHistorico] = useState([]);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [agente, setAgente] = useState({
    idagente: "",
    nombre: "",
    rif: "",
    direccion: "",
    statusproduccion: "",
    credito: 0.0,
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [selected, setSelected] = useState([]);

  const headCells = [
    {
      id: "0",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: "TIPO",
      textAlign: "center",
      disableSorting: false,
    },
    {
      id: "1",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: "AÑO",
      textAlign: "center",
      disableSorting: false,
    },
    {
      id: "2",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: "MES",
      textAlign: "center",
      disableSorting: false,
    },
    {
      id: "3",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: "CONCEPTO",
      textAlign: "center",
      disableSorting: false,
    },
    {
      id: "4",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: "MONTO",
      textAlign: "center",
      disableSorting: false,
    },
    {
      id: "5",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: "INTERES MORA",
      textAlign: "center",
      disableSorting: false,
    },
    {
      id: "6",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: "RECARGOS",
      textAlign: "center",
      disableSorting: false,
    },
    {
      id: "7",
      backgroundColor: "#3b8eed",
      color: "#ffffff",
      label: "TOTAL",
      textAlign: "center",
      disableSorting: false,
    },
  ];

  const {
    TblContainer,
    EnhancedTableHead,
    TblPagination,
    recordsAfterPagingAndSorting,
  } = useTableChecked(deuda, headCells, filterFn);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setSelected(deuda);
      return;
    } else {
      setSelected([]);
    }
  };

  const handleClick = (row) => {
    const selectedIndex = selected.indexOf(row);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, row);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              TIPODEUDA[x.tipodeuda]
                .toString()
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.anio
                .toString()
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.mes
                .toString()
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.concepto
                .toString()
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const blanquear = () => {
    setOperacion(0);
    setDeuda([]);
    setHistorico([]);
    setAgente({
      idagente: "",
      nombre: "",
      rif: "",
      direccion: "",
      statusproduccion: "",
      credito: 0.0,
    });
  };

  const SelectDeudaAgenProd = (data) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/minas/deudas?idagente=${
      data.idagente
    }&fecha=${fechaSistema}&tabconf=${"configminas"}&condic=${"tipodeuda IN(1,11,111,23,24,25)"}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let deu = [];
          let his = [];
          let totdeu = parseFloat(0.0);

          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              totdeu =
                totdeu +
                parseFloat(response.data[i].mondeu) +
                parseFloat(response.data[i].intmoradeu) +
                parseFloat(response.data[i].recargodeu) +
                parseFloat(response.data[i].multa);
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                retenciones: response.data[i].retencion,
                credito: response.data[i].acreditacion,
                totalperi: response.data[i].subtotal,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                nummes: response.data[i].nmes,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
                concepto: response.data[i].txtconcepto,
                tipodeuda: response.data[i].tipodeu,
                tipodecla: response.data[i].tipod,
                total:
                  parseFloat(response.data[i].mondeu) +
                  parseFloat(response.data[i].intmoradeu) +
                  parseFloat(response.data[i].recargodeu) +
                  parseFloat(response.data[i].multa),
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
                concepto: response.data[i].txtconcepto,
                tipodeuda: response.data[i].tipodeu,
                tipodecla: response.data[i].tipod,
                total:
                  parseFloat(response.data[i].mondeu) +
                  parseFloat(response.data[i].intmoradeu) +
                  parseFloat(response.data[i].recargodeu) +
                  parseFloat(response.data[i].multa),
              });
            }
          }
          setDeuda(deu);
          setHistorico(his);
          setSelected([]);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => setActivate(false));
  };

  const onHide = (refress = false) => {
    setShow(false);
    setOperacion(0);
    setSelected([]);
    if (refress) {
      SelectDeudaAgenProd(props.agente);
    }
  };

  const cancelar = () => {
    blanquear();
    props.onHide();
  };

  useEffect(() => {
    if (operacion !== 0) {
      if (selected.length > 0) {
        setShow(true);
      } else if (operacion === 1) {
        setShow(true);
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar La Deuda",
          icono: "informacion",
        });
        setOperacion(0);
      }
    } else {
      setShow(false);
    }
  }, [operacion]);

  const gestionar = (n) => {
    let sigue = false;
    if (n === 1 && accdeudamina.substring(0, 1) === "1") {
      sigue = true;
    } else if (n === 2 && accdeudamina.substring(1, 2) === "1") {
      sigue = true;
    } else if (n === 3 && accdeudamina.substring(2, 3) === "1") {
      sigue = true;
    } else if (n === 4 && accdeudamina.substring(3, 4) === "1") {
      sigue = true;
    }

    if (sigue) {
      setOperacion(n);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No Posee los Permisos para Realizar esta Acción",
        icono: "informacion",
      });
    }
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        SelectDeudaAgenProd(props.agente);
        setAgente(props.agente);
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Gestionar de Deuda Minas</h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid rounded">
          <div className="tab-content" id="ex-with-icons-content">
            <div
              className="tab-pane fade show active"
              id="tab-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <div className="col-md-12 py-1"></div>

              <fieldset className="row border-azul rounded mx-auto col-sm-12">
                <legend className="float-none m-0 w-auto">
                  Datos Generales
                </legend>

                <div className="container row m-0">
                  <div className="col-md-2">
                    <div className="input-group input-group-sm">
                      <label className="form-label fw-bold">Código:</label>{" "}
                      &nbsp; {agente ? agente.idagente : ""}
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="input-group input-group-sm">
                      <label className="form-label fw-bold">Nombre:</label>{" "}
                      &nbsp; {agente ? agente.nombre.trim() : ""}
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="input-group input-group-sm">
                      <label className="form-label fw-bold">Rif:</label> &nbsp;{" "}
                      {agente ? agente.rif : ""}
                    </div>
                  </div>
                  <div className="col-md-10">
                    <div className="input-group input-group-sm">
                      <label className="form-label fw-bold">Dirección:</label>{" "}
                      &nbsp; {agente ? agente.direccion.trim() : ""}
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="input-group input-group-sm">
                      <label className="form-label fw-bold">Estatus:</label>{" "}
                      &nbsp;{" "}
                      {agente && agente.status1x500 === "51"
                        ? "ACTIVO"
                        : "INACTIVO"}
                    </div>
                  </div>
                </div>
              </fieldset>
              <ul className="nav mb-2" id="ex-with-icons" role="tablist">
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link text-light rounded"
                    style={{ backgroundColor: "#F93154" }}
                    id="ex-with-icons-tab-1"
                    data-mdb-toggle="tab"
                    href="#ex-with-icons-tabs-1"
                    role="tab"
                    aria-controls="ex-with-icons-tabs-1"
                    aria-selected="true"
                  >
                    <i className="fas fa-money-check fa-fw me-2" />
                    Deudas
                  </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a
                    className="nav-link text-dark rounded"
                    style={{ backgroundColor: "#25d366" }}
                    id="ex-with-icons-tab-2"
                    data-mdb-toggle="tab"
                    href="#ex-with-icons-tabs-2"
                    role="tab"
                    aria-controls="ex-with-icons-tabs-2"
                    aria-selected="false"
                  >
                    <i className="fas fa-book-open fa-fw me-2" />
                    Historico de Pagos
                  </a>
                </li>
              </ul>
              <div className="tab-content" id="ex-with-icons-content">
                <div
                  className="tab-pane fade show active"
                  id="ex-with-icons-tabs-1"
                  role="tabpanel"
                  aria-labelledby="ex-with-icons-tab-1"
                >
                  <div className="row col-md-12">
                    <div
                      className="col-md-12 "
                      style={{ marginBottom: 10, marginTop: 10 }}
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <input
                            type="text"
                            placeholder="Buscar"
                            className="form-control col-md-12"
                            onChange={handleSearch}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12" style={{ margin: "auto" }}>
                      <TblContainer>
                        <EnhancedTableHead
                          onSelectAllClick={handleSelectAllClick}
                          numSelected={selected.length}
                        />
                        <TableBody>
                          {recordsAfterPagingAndSorting().map((row, index) => {
                            return (
                              <TableRow
                                hover
                                role="checkbox"
                                aria-checked={selected.indexOf(row) !== -1}
                                tabIndex={-1}
                                key={index}
                                selected={selected.indexOf(row) !== -1}
                              >
                                <TableCell padding="checkbox">
                                  <Checkbox
                                    checked={selected.indexOf(row) !== -1}
                                    color="primary"
                                    inputProps={{
                                      "aria-labelledby": `enhanced-table-checkbox-${index}`,
                                    }}
                                    onClick={() => handleClick(row)}
                                  />
                                </TableCell>
                                <TableCell
                                  style={{
                                    textAlign: "center",
                                  }}
                                >
                                  <b>{TIPODEUDA[row.tipodeuda]}</b>
                                </TableCell>
                                <TableCell
                                  style={{
                                    textAlign: "center",
                                  }}
                                >
                                  <b>{row.anio}</b>
                                </TableCell>
                                <TableCell
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  {row.mes.toUpperCase()}
                                </TableCell>
                                <TableCell
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  {row.concepto}
                                </TableCell>
                                <TableCell
                                  style={{
                                    textAlign: "right",
                                  }}
                                >
                                  {formatMoneda(
                                    row.monto
                                      .toString()
                                      .replace(",", "")
                                      .replace(".", ","),
                                    ",",
                                    ".",
                                    2
                                  )}
                                </TableCell>
                                <TableCell
                                  style={{
                                    textAlign: "right",
                                  }}
                                >
                                  {formatMoneda(
                                    row.intereses
                                      .toString()
                                      .replace(",", "")
                                      .replace(".", ","),
                                    ",",
                                    ".",
                                    2
                                  )}
                                </TableCell>
                                <TableCell
                                  style={{
                                    textAlign: "right",
                                  }}
                                >
                                  {formatMoneda(
                                    row.recargo
                                      .toString()
                                      .replace(",", "")
                                      .replace(".", ","),
                                    ",",
                                    ".",
                                    2
                                  )}
                                </TableCell>
                                <TableCell
                                  style={{
                                    textAlign: "right",
                                  }}
                                >
                                  {formatMoneda(
                                    row.total
                                      .toString()
                                      .replace(",", "")
                                      .replace(".", ","),
                                    ",",
                                    ".",
                                    2
                                  )}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </TblContainer>
                      <TblPagination />
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="ex-with-icons-tabs-2"
                  role="tabpanel"
                  aria-labelledby="ex-with-icons-tab-2"
                >
                  <TablaHistoricoMinas tabpago={historico} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row col-md-12">
          <button
            type="button"
            style={{ maxWidth: 150, marginLeft: 3, marginRight: 3 }}
            onClick={() => gestionar(1)}
            className="col-md-3 fw-bold btn btn-primary btn-sm rounded-pill"
          >
            <i className="fas fa-plus"></i> Crear
          </button>
          <button
            type="button"
            style={{ maxWidth: 150, marginLeft: 3, marginRight: 3 }}
            onClick={() => gestionar(2)}
            className="col-md-3 fw-bold btn btn-info btn-sm rounded-pill"
          >
            <i className="fas fa-edit"></i> Ajustar
          </button>
          <button
            type="button"
            style={{ maxWidth: 150, marginLeft: 3, marginRight: 3 }}
            onClick={() => gestionar(3)}
            className="col-md-3 fw-bold btn btn-warning btn-sm rounded-pill"
          >
            <i className="fas fa-sync"></i> Actualizar
          </button>
          <button
            type="button"
            style={{ maxWidth: 150, marginLeft: 3, marginRight: 3 }}
            onClick={() => gestionar(4)}
            className="col-md-3 fw-bold btn btn-danger btn-sm rounded-pill"
          >
            <i className="fas fa-trash"></i> Eliminar
          </button>
        </div>
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
      <ModalActualizarDeudaMina
        show={show}
        operacion={operacion}
        deuda={selected}
        agente={agente}
        onHide={onHide}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/minas/modalGestionDeudaMina.js